import * as actions from './actions';
import * as logics from './logics';
import * as reducers from './reducers';
import * as selectors from './selectors';
import * as testdata from './testdata';
const canvas = { reducers, actions, selectors, testdata, logics };
export default canvas;
